import { render, staticRenderFns } from "./ItemStatusUpdate.vue?vue&type=template&id=723ec77c&scoped=true"
import script from "./ItemStatusUpdate.vue?vue&type=script&lang=js"
export * from "./ItemStatusUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723ec77c",
  null
  
)

export default component.exports